<template>
  <div class="quick-response-container">
    <div class="quick-response-title">
      <div id="quick-response-text-title">{{ $t('quickResponse') | capitalize }}</div>
      <v-spacer/>
      <v-btn flat small @click="openDialogCreateQuickResponse">
        <v-icon right left size="14" color="#ffff">mdi-plus-circle</v-icon>
        <span class="btn-text">{{ $t('createNew') | capitalize }}</span></v-btn>
        <v-btn flat small @click="exportAgentQuickResponse({'sortBy':sortBy,'search':search})" :disabled="isLockReport">
        <v-icon right left size="14" color="#ffff">mdi-export</v-icon>
        <span v-if = "!isLockReport" class="btn-text">{{ $t('export') | capitalize }}</span>
        <span v-if = "isLockReport" class="btn-text-disable">{{ $t('export') | capitalize }}</span></v-btn>
        <!-- <v-btn flat small @click="importExcel">
        <v-icon right left size="14" color="#ffff">mdi-import</v-icon>
        <span class="btn-text">{{ $t('import') | capitalize }}</span></v-btn> -->
        <v-btn flat small @click="openDialogImportAgentQuickResponse">
        <v-icon right left size="14" color="#ffff">mdi-import</v-icon>
        <span class="btn-text">{{ $t('import') | capitalize }}</span></v-btn>
      <v-btn flat icon class="mx-0">
        <v-icon color="#fff" size="20" @click="closeAgentQuickResponse">mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="quick-response-content">
      <div class="filter-box">
        <div class="search-quick-response">
          <v-icon size="20" class="search-quick-response-icon">mdi-magnify</v-icon>
          <input v-model='search' type="text" autocomplete="nope" :placeholder="$t('search') | capitalize"/>
        </div>
        <div class="sort-quick-response">
          <span class="sort-label">{{ $t('sortBy') | capitalize }}:</span>
          <v-select
              v-model="sortBy"
              height="37"
              hide-details
              append-icon="mdi-chevron-down"
              solo
              flat
              :items="selectItems"
              item-text="label"
          >
            <template #selection="{item}">
              <span class="selection-txt">{{ item.label }}</span>
            </template>
          </v-select>
        </div>
      </div>
      <div class="list-quick-response scroll-thin">
        <AgentQuickResponseLoading v-if="loading"/>
        <div v-else class="quick-response-item" v-for="item of listTemplateFilters" v-bind:key="item._id">
          <div class="list-quick-response-content" @click="onSelect(item)">
            <ul>
              <li class="content-title">
                {{ item.title }}
              </li>
              <li class="content-desc">
                {{ item.content }}
              </li>
            </ul>
          </div>
          <div class="list-quick-response-action">
            <v-btn v-if="item.type===0" flat icon class="btn-edit" @click="openDialogUpdateQuickResponse(item)">
              <img src="@/assets/icons/pencil-line.svg" alt=""/>
            </v-btn>
            <v-btn v-if="item.type===0" flat icon class="btn-delete" @click="deleteAgentQuickResponse(item)">
              <img src="@/assets/icons/delete.svg" alt=""/>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import AgentQuickResponseLoading from "components/custom/AgentQuickResponseLoading";
import _ from "lodash";
import utils from "@/services/utils";
import i18n from "@/plugins/i18n";
import StaffService from "@/services/staff.service";
import AppService from "@/services/app.service";
export default {
  name: "AgentQuickResponse",
  components: {AgentQuickResponseLoading},
  data() {
    return {
      search: "",
      sortBy: "time",
      selectItems: [
        {label: `${i18n.t('time')}`, value: 'time'},
        {label: `${i18n.t('oftenUsed')}`, value: 'often_used'},
      ],
      hasManageRole: false,
    }
  },
  mounted() {
    this.checkRole()
    this.fetchCurrentAutoAssignCfg()
  },
  computed: {
    ...mapState('agentQuickResponse', ['loading', 'listResponseTemplate','isLockReport']),
    ...mapState(['user', 'token', 'bot', 'botStaffList']),
    ...mapState('autoAssign',['autoAssignCfg']),
    ...mapState(['notifyBotChat']),
    listTemplateFilters: function () {
      let key = utils.removeVietnameseTones(this.search.trim().toLowerCase());
      let list = this.listResponseTemplate;
      //Filter search
      if (key) {
        list = _.filter(this.listResponseTemplate, (item) => {
          let _title = utils.removeVietnameseTones(item.title.toLowerCase())
          let _group = utils.removeVietnameseTones((item.group || '').toLowerCase())
          return _title.includes(key) || _group.includes(key)
        })
      }
      let foundSupporter = this.autoAssignCfg.supporters.find(item => item.id === this.user.id);
      let currentRsCategories = (foundSupporter && foundSupporter.auto_assign_config.request_support_categories) ? foundSupporter.auto_assign_config.request_support_categories : []
      
      if(this.autoAssignCfg.supporters){
        list = _.filter(list, (item) => {
          return  (!item.skillGroup || parseInt(item.skillGroup)===0) || currentRsCategories.includes(parseInt(item.skillGroup))
        })
      }
      switch (this.sortBy) {
        case 'time':
          list = _.orderBy(list, ['created_time'], ['desc'])
          break;
        case 'often_used':
          list = _.orderBy(list, ['numberOfUses'], ['desc'])
          break;
        default:
          break;
      }
      return list
    }
  },
  watch: {
    '$i18n.locale': {
      handler(val) {
        this.selectItems = [
          {label: `${i18n.t('time')}`, value: 'time'},
          {label: `${i18n.t('oftenUsed')}`, value: 'often_used'},
        ]
      }
    },
    '$route'() {
      let botCode = this.$route.params.bot_code
      if (botCode) {
        this.checkRole()
      }
    },
    notifyBotChat(val) {
      if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.SESSION_REPORT_STATUS) {
        if (val.data.is_success) {
          AppService.toastSuccess("Excels report success. Please check email")
        }
        else {
        AppService.handleRequestError("Excels report failed. Please contact administrator")
        }
        this.unLockReport()
      }
    }
  },
  methods: {
    ...mapActions('agentQuickResponse', ['closeAgentQuickResponse', 'deleteAgentQuickResponse', 'exportAgentQuickResponse','unLockReport']),
    ...mapActions('dialog', ['openDialogCreateQuickResponse', 'openDialogUpdateQuickResponse', 'openDialogImportAgentQuickResponse']),
    ...mapActions('autoAssign', ['fetchCurrentAutoAssignCfg']),
    checkRole() {
      return this.hasManageRole = StaffService.checkStaffHasRole(this.$route.params.bot_code, this.user.id, [10, 9, 5])
    },
    onSelect(template) {
      this.$emit('select', template)
    }
  }
}
</script>

<style scoped lang="scss">
@import "components/style/agent-quick-response";
</style>
